import { AffectedStaff } from '../../lib/types/models/affectedStaff/affected-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export type ReassignStaffRequestInput = {
  staffRequestId: number
  affectedStaffId: number
}

export function reassignStaffRequest(input: ReassignStaffRequestInput) {
  const { affectedStaffId, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.reassignStaffRequest.url, { id: affectedStaffId }))
    .post<AffectedStaff>(rest)
}
